import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { FitActiveWorkersWoMedicalExaminationService, FitActiveWorkersWoMedicalExaminationServiceData } from "../../services/occupationalRiskPreventionKpi/fitActiveWorkersWoMedicalExamination.service";
import { FitActiveWorkersWoMedicalExaminationDetailService, FitActiveWorkersWoMedicalExaminationDetailServiceData, FitWorkerDetail } from "../../services/occupationalRiskPreventionKpi/fitActiveWorkersWoMedicalExaminationDetail.service";
import { ColumnDefinition, DateColumnDefinition, EmailColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class FitActiveWorkersWoMedicalExaminationDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'fit-active-workers-wo-medical-examination-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class FitActiveWorkersWoMedicalExaminationKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<FitActiveWorkersWoMedicalExaminationService, FitActiveWorkersWoMedicalExaminationServiceData, FitActiveWorkersWoMedicalExaminationServiceData, FitActiveWorkersWoMedicalExaminationDetailService, FitActiveWorkersWoMedicalExaminationDetailServiceData, FitActiveWorkersWoMedicalExaminationDetailData>
    implements OnDestroy {
    public getClassName() { return "FitActiveWorkersWoMedicalExaminationKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: FitActiveWorkersWoMedicalExaminationService, detailService: FitActiveWorkersWoMedicalExaminationDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: FitActiveWorkersWoMedicalExaminationServiceData): FitActiveWorkersWoMedicalExaminationServiceData {
        return data;
    }

    protected getDefaultSummaryData(): FitActiveWorkersWoMedicalExaminationServiceData {
        let data = new FitActiveWorkersWoMedicalExaminationServiceData();
        data.consultant = 0;
        data.office = 0;
        data.updateTimestamp = new Date();

        return data;
    }

    protected extractUpdateTime(data: FitActiveWorkersWoMedicalExaminationServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: FitActiveWorkersWoMedicalExaminationDetailServiceData, args: any): FitActiveWorkersWoMedicalExaminationDetailData {
        if (data.workers) {
            if (args && args.filter && args.filter.consultant) {
                let columnDefinitions = this.getColumnsDefaultConsultant();

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.workers).find(x => x.nif == consultantNif) || { name: null }).name;
                        columnDefinitions[4].filterTerm = [consultantName];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let worker of data.workers) {
                    if (worker.nif.toUpperCase() == consultantNif) {
                        tabledata.push([
                            worker.workerName,
                            worker.workerPhone,
                            worker.workerEmail,
                            {
                                date: worker.medicalExaminationRequestDate,
                                status: worker.medicalExaminationStatus
                            },
                            worker.name,
                            worker.workCentre,
                        ]);
                    }
                    else {

                        tabledata2.push([
                            worker.workerName,
                            worker.workerPhone,
                            worker.workerEmail,
                            {
                                date: worker.medicalExaminationRequestDate,
                                status: worker.medicalExaminationStatus
                            },
                            worker.name,
                            worker.workCentre,
                        ]);
                    }
                }

                let arrayOrdenado = tabledata.concat(tabledata2);

                return new FitActiveWorkersWoMedicalExaminationDetailData(columnDefinitions, arrayOrdenado);
            } else {
                let columnDefinitions = this.getColumnsDefault();

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.workers).find(x => x.nif == consultantNif) || { name: null }).name;
                        columnDefinitions[0].filterTerm = [consultantName];
                    }
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let worker of data.workers) {
                    if (worker.nif.toUpperCase() == consultantNif) {
                        tabledata.push([
                            worker.name,
                            worker.workerName,
                            worker.workerPhone,
                            worker.workerEmail,
                            {
                                date: worker.medicalExaminationRequestDate,
                                status: worker.medicalExaminationStatus
                            },
                            worker.workCentre,
                        ]);
                    }
                    else {

                        tabledata2.push([
                            worker.name,
                            worker.workerName,
                            worker.workerPhone,
                            worker.workerEmail,
                            {
                                date: worker.medicalExaminationRequestDate,
                                status: worker.medicalExaminationStatus
                            },
                            worker.workCentre,
                        ]);
                    }
                }

                let arrayOrdenado = tabledata.concat(tabledata2);

                return new FitActiveWorkersWoMedicalExaminationDetailData(columnDefinitions, arrayOrdenado);
            }
        }
        else return this.getDefaultDetailData();
    }

    private extractConsultants(data: FitWorkerDetail[]): { nif: string, name: string }[] {
        let nifs: { nif: string, name: string }[] = [];

        if (data) {
            data.forEach(x => {
                if (!nifs.find(y => x.nif.toUpperCase() == y.nif)) nifs.push({ nif: x.nif.toUpperCase(), name: x.name });
            })
        }

        return nifs;
    }

    protected getDefaultDetailData(): FitActiveWorkersWoMedicalExaminationDetailData {
        let columnDefinitions = this.getColumnsDefault();

        return new FitActiveWorkersWoMedicalExaminationDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }

    /**
     * Método que define las columnas, sus etiquetas y medidas
     * @returns Arreglo de columnas por defecto para la grilla
     */
    public getColumnsDefault(): any {

        let columnDefinitions = [
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Trabajador"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha Apto RRMM", (data) => {
                if (data.date == null || data.date == '' || data.date == undefined) {
                    return '';
                }
                else {
                    let date = moment(data.date).startOf("day");
                    if (date.isSame(moment(new Date("0001-01-01T00:00:00")))) {
                        return data.status;
                    } else {
                        if (date.isValid()) return date.format("DD/MM/YYYY");
                        else return data.status;
                    }
                }
            }, true, 155),
            new TextColumnDefinition("Cliente", null, true)
        ];

        return columnDefinitions;
    }

    /**
     * Método que define las columnas, sus etiquetas y medidas
     * @returns Arreglo de columnas por defecto para la grilla
     */
    public getColumnsDefaultConsultant(): any {

        let columnDefinitions = [
            new TextColumnDefinition("Trabajador"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha Apto RRMM", (data) => {
                if (data.date == null || data.date == '' || data.date == undefined) {
                    return '';
                }
                else {
                    let date = moment(data.date).startOf("day");
                    if (date.isSame(moment(new Date("0001-01-01T00:00:00")))) {
                        return data.status;
                    } else {
                        if (date.isValid()) return date.format("DD/MM/YYYY");
                        else return data.status;
                    }
                }
            }, true, 155),
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Cliente", null, true)
        ];

        return columnDefinitions;
    }
}
